import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { ThemeProvider } from "@/context/ThemeContext";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Symptoms from "@/pages/Symptoms";
import Organs from "@/pages/Organs";
import OrganDetail from "@/pages/OrganDetail";
import Clock from "@/pages/Clock";
import Elements from "@/pages/Elements";
import ElementDetail from "@/pages/ElementDetail";
import Emotions from "@/pages/Emotions";
import Flavors from "@/pages/Flavors";
import Foods from "@/pages/Foods";
import Teas from "@/pages/Teas";
import SelfCare from "@/pages/SelfCare";
import Registros from "@/pages/Registros";
import Safety from "@/pages/Safety";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <ThemeProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Layout>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/sintomas" element={<Symptoms />} />
              <Route path="/orgaos" element={<Organs />} />
              <Route path="/orgaos/:id" element={<OrganDetail />} />
              <Route path="/relogio" element={<Clock />} />
              <Route path="/elementos" element={<Elements />} />
              <Route path="/elementos/:id" element={<ElementDetail />} />
              <Route path="/emocoes" element={<Emotions />} />
              <Route path="/sabores" element={<Flavors />} />
              <Route path="/alimentos" element={<Foods />} />
              <Route path="/chas" element={<Teas />} />
              <Route path="/autocuidado" element={<SelfCare />} />
              <Route path="/registros" element={<Registros />} />
              <Route path="/seguranca" element={<Safety />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </div>
    </ThemeProvider>
  );
}

export default App;
